import Modal from './Modal'

export default Modal
// eslint-disable-next-line import/export
export * from './Modal'
